import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';

export const trackLedSettingAction: (answer: boolean) => FirebaseActionTypes.IAnalyticsEventAction = (answer) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'e_autonomy_no_control',
    parameters: [
      {
        key: 'Control',
        value: answer ? 'manual' : 'auto',
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};
